var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paging-box-el"},[_c('div',{staticClass:"paging-wrap"},[_c('el-pagination',{attrs:{"background":"","layout":" prev, pager, next","current-page":_vm.currentPage,"page-size":_vm.pageSize,"total":_vm.total},on:{"current-change":_vm.currentChange}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }